import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import LoadCSS from './scripts/loadCSS';
import Popover from './popover';

export default class Header extends Component {
  state = {
    isTop: true,
    isSticky: false,
    isTool: false
  };

  componentDidMount() {
    setTimeout(function(){
      document.body.classList.add('loaded')
    }, 500)
    window.onload = (e) => {
      if(document.getElementById('sevenTool')){
        this.setState({
          isTool: true
        })
      }

    }
    document.addEventListener("scroll", () => {
      const isTop = window.scrollY < 100;
      if (isTop !== this.state.isTop) {
        this.setState({ isTop });
      }
      if(window.scrollY > 30){
        document.body.classList.add('sticky-header')
        this.setState({ isSticky: true })
      } else {
        document.body.classList.remove('sticky-header')
        this.setState({ isSticky: false })
      }
    });
  }
  render() {
    const isSevenTool = this.state.isTool;
    let headerImage;
    if(isSevenTool){
      headerImage = <NavLink to="/"><img src={this.state.isSticky ? '/images/7tool-logo-dark-new.png' : '/images/7tool-logo-white-new.png'} alt="" /></NavLink>;
    } else {
      headerImage = <NavLink to="/"><img src={this.state.isSticky ? '/images/7tool-logo-dark-new.png' : '/images/7tool-logo-white-new.png'} alt="" /></NavLink>;
    }
    return (
      <>
        <Popover/>
        <LoadCSS/>
        <header className="siteHeader animated slideInDown">
          <div className="logoLeft">
            {headerImage}
          </div>
          <div className="headerRight">
          </div>
        </header>
      </>
    );
  }
}
